<wide-dialog-wrapper
  [backgroundColor]="'#9FC5E8'"
  [dialogTitle]="'Manage Revenue Share'"
  [disabled]="false"
  [deleteTitle]="'Delete'"
  [deleteText]="deleteText"
  [delete]="true"
  [successLabel]="'CLOSE'"
  (onSubmit)="exit()"
  (onDelete)="delete()"
>
  <div *ngIf="loading">Loading snapshot...</div>
  <share-code *ngIf="baseUrl + 'revenue/' + data.eventId + '/' + data.info.id as shareUrl"
    [shareType]="'revenue'"
    [shareCode]="data.info.id"
    [fullUrl]="shareUrl"
    [statusOptions]="statusOptions"
    [selectedStatus]="data.info.active ? 'Active' : 'Off'"
    [hideTitle]="true"
    [hideJson]="true"
    [manualPrint]="true"
    [emailGenerator]="emailGenerator.bind(this)"
    [showPrint]="!!data.info.active"
    (changeStatus)="changeStatus()"
    (print)="print(shareUrl)"
  ></share-code>
  <budget-revenue-share-view *ngIf="!!budget" [info]="data.info" [budget]="budget"></budget-revenue-share-view>
</wide-dialog-wrapper>

